// mergeGuestWishlist.js
import BrowserDatabase from 'Util/BrowserDatabase';
import { CLEAR_GUEST_WISHLIST } from 'Store/GuestWishlist/GuestWishlist.action';

export async function mergeGuestWishlist(dispatch) {
    console.log('Starting guest wishlist merge');

    const guestWishlist = BrowserDatabase.getItem('guest_wishlist_products') || {};
    const itemsArray = Object.values(guestWishlist).map(item => ({
        sku: item.sku,
        ...(item.product_option && { product_option: item.product_option }),
        quantity: item.quantity || 1
    }));

    const existing = BrowserDatabase.getItem('wishlist_products') || [];
    const existingArr = Array.isArray(existing) ? existing : Object.values(existing);
    const existingSkus = new Set(existingArr.map(i => i.sku));

    const itemsToAdd = itemsArray.filter(i => !existingSkus.has(i.sku));
    if (!itemsToAdd.length) {
        console.log('All guest items already in customer wishlist.');
        dispatch({ type: CLEAR_GUEST_WISHLIST });
        return;
    }

    console.log('Will add:', itemsToAdd);

    // dynamically load the dispatcher
    const { default: wishlistDispatcher } = await import(
        /* webpackChunkName: "dispatchers" */ 'Store/Wishlist/Wishlist.dispatcher'
        );

    // call it
    await Promise.all(
        itemsToAdd.map(item => wishlistDispatcher.addItemToWishlist(dispatch, item))
    );

    dispatch({ type: CLEAR_GUEST_WISHLIST });
    console.log('Merge complete');
}
